import { ActionTree } from "vuex";
import * as types from "@/store/constants/types";
const actions: ActionTree<any, any> = {
  async [types.INITIAL_TIME_STAMP](
    { state, commit, dispatch, getters },
    payload: any
  ) {
    const initTime = new Date().valueOf(); 
    commit(types.INITIAL_TIME_STAMP, initTime);
  }
};

export default actions;




